import { Checkbox, FormControlLabel, FormGroup, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles({
  checkboxGroupWrapper: {
    display: "flex",
    flexDirection: "row" as "row",
    padding: "0 24px"
  },
  checkboxesError: {
    background: "#ffebee"
  },
  container: {},
  label: {
    color: "#4d4d4e",
    fontSize: "1.4rem"
  }
});

interface IOwnProps {
  options: string[];
  vertical: boolean;
  readOnly: boolean;
  onChange?: (value: number | null) => void;
  value: number | null;
  invalid?: boolean;
}

export const CheckboxGroup = ({
  options,
  vertical = false,
  readOnly,
  onChange,
  value = null,
  invalid = false
}: IOwnProps) => {
  const classes = useStyles();
  const handleChange = React.useCallback(
    (newValue: number) => {
      return (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        if (onChange) {
          onChange(checked ? newValue : null);
        }
      };
    },
    [onChange]
  );

  const wrapperClassName = React.useMemo(() => {
    const classNames = ["checkbox-group"];
    if (!vertical) {
      classNames.push(classes.checkboxGroupWrapper);
    }
    if (invalid) {
      classNames.push(classes.checkboxesError);
    }
    return classNames.join(" ");
  }, [invalid, vertical]);

  return (
    <FormGroup className={wrapperClassName}>
      {options.map((label: any, index: number) => {
        return (
          <FormControlLabel
            key={index}
            className={classes.label}
            control={<Checkbox checked={index === value} disabled={readOnly} onChange={handleChange(index)} />}
            label={label}
          />
        );
      })}
    </FormGroup>
  );
};
